<template>
    <div v-loading="loadAllElement">
        <el-row v-if="activeTableZipCodeAndSelectSubDistrict">
            <el-col :span="8" :offset="16">
                <el-button
                    type="primary"
                    plain
                    @click="exportFileToExcel"
                >
                Export Zipcode Excel
                </el-button>
            </el-col>
        </el-row>
        <h3>{{buttonMode.name}}</h3>
        <el-form >
            <el-form-item>
                <el-row :gutter="24">
                    <el-col :span="8" :offset="1">
                        <el-input
                            v-model="searchText"
                            type="text"
                            placeholder="ค้นหา"
                            @input="onSearchText"/>
                    </el-col>
                    <el-col :span="8">
                        <el-button type="primary" plain @click="getAllData">{{'เรียกข้อมูล' + buttonMode.name + 'ทั้งหมด'}}</el-button>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col v-show="activeSelectProvince" :span="6" :offset="1">
                        <el-select
                            v-model="provinceForm"
                            filterable
                            placeholder="จังหวัด"
                        >
                            <el-option
                                v-for="(item, index) in provinceInfo"
                                :key="index"
                                :label="item.provinceName"
                                :value="item.provinceName"
                                autocomplete="off"
                            />
                        </el-select>
                    </el-col>
                    <el-col v-show="activeTableZipcodeAndSubDistrictAndSelectDistrict" :span="6" :offset="2">
                        <el-select
                            v-model="districtForm"
                            filterable
                            placeholder="อำเภอ"
                        >
                            <el-option
                                v-for="(item, index) in districtArray"
                                :key="index"
                                :label="item.districtName"
                                :value="item.districtName"
                                autocomplete="off"/>
                        </el-select>
                    </el-col>
                    <el-col v-show="activeTableZipCodeAndSelectSubDistrict" :span="6" :offset="2">
                        <el-select
                            v-model="subDistrictForm"
                            filterable
                            placeholder="ตำบล"
                        >
                            <el-option
                                v-for="(item, index) in subDistrictArray"
                                :key="index"
                                :label="item.subDistrictName"
                                :value="item.subDistrictName"
                                autocomplete="off"/>
                        </el-select>
                    </el-col>
                </el-row>
            </el-form-item>
        </el-form>
        <data-tables
            v-show="activeTbProvinceAndDistrict"
            :data="data"
            v-loading="loadState"
            :page-size="10"
            :pagination-props="{ pageSizes: [10, 20, 50, 100], pagerCount: 5 }"
        >
            <el-table-column :label="buttonMode.name" prop="propName">
            </el-table-column>
            <el-table-column fixed="right" label="จัดการ" width="150" >
                <template slot-scope="scope">
                    <el-button
                        :key="scope.$index"
                        size="small" icon="el-icon-edit"
                        type="warning"
                        plain
                        @click="editAddress(scope.row)"/>
                </template>
            </el-table-column>
        </data-tables>
        <el-row v-show="activeTableZipcodeAndSubDistrictAndSelectDistrict">
            <el-col v-show="activeTableZipCodeAndSelectSubDistrict" :span="24">
                <el-table v-loading="loadState" :data="data">
                    <el-table-column prop="detail" label="รหัสไปรษณีย์"></el-table-column>
                    <el-table-column prop="provinceName" label="จังหวัด"></el-table-column>
                    <el-table-column prop="districtName" label="อำเภอ"></el-table-column>
                    <el-table-column prop="subDistrictName" label="ตำบล"></el-table-column>
                    <el-table-column label="จัดการ" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                :key="scope.$index"
                                size="small" icon="el-icon-edit"
                                type="warning"
                                plain
                                @click="editAddress(scope.row)"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col v-show="activeTableSubDistrict" :span="24">
                <el-table v-loading="loadState" :data="data">
                    <el-table-column prop="subDistrictName" label="ตำบล"></el-table-column>
                    <el-table-column label="จัดการ" fixed="right">
                        <template slot-scope="scope">
                            <el-button
                                :key="scope.$index"
                                size="small"
                                icon="el-icon-edit"
                                type="warning"
                                plain
                                @click="editAddress(scope.row)"/>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
            <el-col style="margin-top:10px;">
                <el-pagination
                    :current-page.sync="pagination.currentPage"
                    :page-sizes="pagination.pageSizes"
                    :page-size="10"
                    layout="prev, pager, next, sizes"
                    :total="pagination.allPage * pagination.limit"
                    @size-change="changeLimitPage"
                    @current-change="changeCurrentPage"/>
            </el-col>
        </el-row>
        <div>
            <ZipcodeSystemDialog
                :addressInfo.sync="addressDetail"
                @refeshInfo="refeshData"/>
        </div>
    </div>
</template>
<script>
import ZipcodeSystemDialog from '@/components/Courier/zipCodeSystem/ZipcodeSystemDialog'
import fgApi from '@/services/fillgoods'
import mixinExcel from '@/mixins/exportExcel.js'

export default {
    name: 'ZipcodeSystemTable',
    mixins: [mixinExcel],
    components: {
        ZipcodeSystemDialog
    },
    props: {
        buttonMode: {
            type: Object,
            default: () => {
                return {
                    key: '',
                    name: ''
                }
            }
        }
    },
    data () {
        return {
            addressDetail: {
                dialog: false,
                data: {
                    mode: {
                        name: ''
                    }
                }
            },
            searchText: '',
            data: [],
            zipcodeInfo: [],
            provinceInfo: [],
            districtInfo: [],
            subDistrictInfo: [],
            loadState: false,
            provinceForm: '',
            districtForm: '',
            subDistrictForm: '',
            provId: null,
            distId: null,
            districtArray: [],
            subDistrictArray: [],
            subDistId: null,
            timeSearchLimit: null,
            pagination: {
                limit: 10,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [10, 20, 50, 100, 200]
            },
            loadAllElement: false
        }
    },
    computed: {
        activeTableZipcodeAndSubDistrictAndSelectDistrict () {
            return this.buttonMode.key === 0 || this.buttonMode.key === 3
        },
        activeTbProvinceAndDistrict () {
            return this.buttonMode.key !== 0 && this.buttonMode.key !== 3
        },
        activeSelectProvince () {
            return this.buttonMode.key === 2 || this.buttonMode.key === 3 || this.buttonMode.key === 0
        },
        activeTableZipCodeAndSelectSubDistrict () {
            return this.buttonMode.key === 0
        },
        activeTableSubDistrict () {
            return this.buttonMode.key === 3
        }
    },
    watch: {
        async buttonMode (val) {
            console.log('------', val)
            this.clearForm()
            // await this.getProvince()
            this.data = []
        },
        provinceForm (val) {
            if (val === '') {
                this.provinceSelect(val)
            } else {
                this.provinceSelect(val)
            }
        },
        districtForm (val) {
            if (val) {
                this.districtSelect(val)
            }
        },
        subDistrictForm (val) {
            if (val) {
                this.subDistrictSelect(val)
            }
        }
    },
    async mounted () {
        await this.getProvince() // get provinceInfo
        this.data = []
    },
    methods: {
        async getAllData () {
            await this.clearForm()
            await this.getAddress()
        },
        clearForm () {
            this.pagination.allPage = 1
            this.pagination.limit = 10
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.searchText = ''
            this.provinceForm = ''
            this.districtForm = ''
            this.subDistrictForm = ''
            this.provId = null
            this.distId = null
            this.subDistId = null
            this.districtArray = []
            this.subDistrictArray = []
        },
        clearProvince () {
            this.pagination.allPage = 1
            this.pagination.limit = 10
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.searchText = ''
            this.provinceForm = ''
            this.districtForm = ''
            this.subDistrictForm = ''
        },
        clearDistrict () {
            console.log('test')
            this.pagination.allPage = 1
            this.pagination.limit = 10
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.districtForm = ''
            this.subDistrictForm = ''
        },
        async refeshData (val) { // reloading
            this.loadState = true
            switch (val) {
            case 0:
                await this.getZipcode()
                break
            case 1:
                await this.getProvince()
                break
            case 2:
                await this.getDistrict()
                break
            case 3:
                await this.getSubDistrict()
                break
            default:
                console.log('key not macth')
                break
            }
            this.loadState = false
        },
        onSearchText (val) {
            this.searchText = val
            this.pagination.currentPage = 1
            this.pagination.offset = 0
            clearTimeout(this.timeSearchLimit)
            this.timeSearchLimit = setTimeout(() => {
                this.getAddress() // search data by key
            }, 500)
        },
        changeLimitPage (val) {
            console.log('limit page:', val)
            this.pagination.limit = val
            this.getAddress()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) -
            this.pagination.limit
            this.getAddress()
            // console.log(val)
        },
        async provinceSelect (val) {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.districtForm = ''
            this.subDistrictForm = ''
            this.provId = null
            this.distId = null
            this.subDistId = null
            this.provinceForm = val
            this.districtArray = []
            this.subDistrictArray = []
            console.log('provinceName input', this.provinceForm)
            await this.provinceInfo.forEach((e) => {
                if (this.provinceForm === e.provinceName) {
                    this.provId = e.provinceId
                }
            })
            console.log('test', this.provId)
            await this.getDistrict()
            this.districtInfo.forEach((e) => {
                if (e.provinceId === this.provId) {
                    this.districtArray.push(e)
                }
            })
            await this.getAddress()
        },
        async getSubDistrictSelectList () {
            this.pagination.limit = -1
            await this.getSubDistrict()
        },
        async getSubDistrictTableList () {
            this.pagination.limit = 10
            await this.getAddress()
        },
        async districtSelect (val) {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.subDistrictForm = ''
            this.distId = null
            this.subDistId = null
            this.subDistrictArray = []
            this.districtForm = val
            this.districtInfo.forEach((e) => {
                if (e.districtName === this.districtForm) {
                    this.distId = e.districtId
                }
            })
            console.log('dist-id', this.distId)
            await this.getSubDistrictSelectList()
            this.subDistrictInfo.forEach((e) => {
                if (e.provinceId === this.provId) {
                    this.subDistrictArray.push(e)
                }
            })
            console.log('subDist-me', this.subDistrictArray)
            await this.getSubDistrictTableList()
        },
        async subDistrictSelect (val) {
            this.pagination.offset = 0
            this.pagination.currentPage = 1
            this.subDistId = null
            this.subDistrictForm = val
            this.subDistrictInfo.forEach((e) => {
                if (e.subDistrictName === this.subDistrictForm) {
                    this.subDistId = e.subDistrictId
                }
            })
            await this.getAddress()
        },
        async getZipcode () {
            try {
                this.data = []
                this.zipcodeInfo = []
                let paramZip = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    province_id: this.provId,
                    district_id: this.distId,
                    subDistrict_id: this.subDistId
                }
                console.log('--------', paramZip)
                let resZip = await fgApi.order.searchZipcode(paramZip)
                console.log(resZip.data)
                this.pagination.allPage = (resZip.data.all / this.pagination.limit)
                // console.log('page', this.pagination.allPage)
                if (resZip.success) {
                    resZip.data.zipcode.forEach(element => {
                        let dataZip = element
                        dataZip.propName = element.detail
                        this.zipcodeInfo.push(element)
                    })
                    this.zipcodeInfo.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                    // console.log('show', this.zipcodeInfo)
                    this.data = this.zipcodeInfo
                    console.log('zipcode', this.data)
                } else {
                    this.$message.error('Get zipcode not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
        },
        async getProvince () {
            try {
                this.data = []
                this.provinceInfo = []
                let paramProv = {
                    search: this.searchText
                }
                console.log(paramProv)
                let resProv = await fgApi.order.searchProvince(paramProv)
                console.log(resProv.data)
                if (resProv.success) {
                    resProv.data.provinces.forEach(element => {
                        let dataProv = element
                        dataProv.propName = element.provinceName
                        this.provinceInfo.push(dataProv)
                        // this.provinceInfo.name.push({ name: element.provinceName })
                    })
                    this.provinceInfo.sort((a, b) => {
                        return a.provinceId - b.provinceId
                    })
                    // console.log('province', this.provinceInfo)
                    this.data = this.provinceInfo
                    console.log('province', this.provinceInfo)
                } else {
                    this.$message.error('Get province not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
        },
        async getDistrict () {
            try {
                this.data = []
                this.districtInfo = []
                let paramDist = {
                    search: this.searchText,
                    province_id: this.provId
                }
                let resDist = await fgApi.order.searchDistrict(paramDist)
                console.log(resDist.data)
                if (resDist.success) {
                    resDist.data.districts.forEach(element => {
                        let dataDist = element
                        dataDist.propName = element.districtName
                        this.districtInfo.push(dataDist)
                    })
                    this.districtInfo.sort((a, b) => {
                        return a.districtId - b.districtId
                    })
                    console.log('provinceId', this.provId)
                    if (this.provId === 77) {
                        this.districtInfo = this.districtInfo.filter(e => {
                            return e.districtId < 999
                        })
                    }
                    this.data = this.districtInfo
                    console.log('district', this.districtInfo)
                } else {
                    this.$message.error('Get district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
        },
        async getSubDistrict () {
            try {
                this.data = []
                this.subDistrictInfo = []
                let paramSubDist = {
                    search: this.searchText,
                    limit: this.pagination.limit,
                    offset: this.pagination.offset,
                    province_id: this.provId,
                    district_id: this.distId
                }
                console.log('check-sub-dist', paramSubDist)
                let resSubDist = await fgApi.order.searchSubDistrict(paramSubDist)
                console.log(resSubDist.data)
                this.pagination.allPage = (resSubDist.data.all / this.pagination.limit)
                if (resSubDist.success) {
                    resSubDist.data.subDistricts.forEach(element => {
                        let dataSubDist = element
                        dataSubDist.propName = element.subDistrictName
                        this.subDistrictInfo.push(dataSubDist)
                    })
                    this.subDistrictInfo.sort((a, b) => {
                        return a.subDistrictId - b.subDistrictId
                    })
                    this.data = this.subDistrictInfo
                    console.log('subdist', this.subDistrictInfo)
                } else {
                    this.$message.error('Get sub-district not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
        },
        async getAddress () {
            this.loadState = true
            switch (this.buttonMode.key) {
            case 0:
                await this.getZipcode()
                break
            case 1:
                await this.getProvince()
                break
            case 2:
                await this.getDistrict()
                break
            case 3:
                await this.getSubDistrict()
                break
            default:
                console.log('key not macth')
                break
            }
            this.loadState = false
        },
        editAddress (row) {
            this.addressDetail.dialog = !this.addressDetail.dialog
            this.addressDetail.data = row
            this.addressDetail.data.mode = this.buttonMode
        },
        async exportFileToExcel () {
            this.loadAllElement = true
            let paramZip = {
                search: ''
            }
            console.log('--------', paramZip)
            let resZip = await fgApi.order.searchZipcode(paramZip)
            console.log(resZip.data)
            let exportData = [['จังหวัด', 'อำเภอ', 'ตำบล', 'รหัสไปรษณีย์']]
            try {
                // console.log('page', this.pagination.allPage)
                if (resZip.success) {
                    resZip.data.zipcode.forEach(element => {
                        let arrData = [
                            element.provinceName, element.districtName, element.subDistrictName, element.detail
                        ]
                        exportData.push(arrData)
                    })
                    console.log('export files', exportData)
                    this.saveExcel(exportData, 'Zipcode_Address_Info')
                } else {
                    this.$message.error('Get zipcode not success')
                }
            } catch (error) {
                this.$message.error('Oops, Api is ' + error + '!')
            }
            this.loadAllElement = false
        }
    }
}
</script>
<style lang="scss" scoped>
    .el-row {
        margin-bottom: 10px;
    }
</style>
